import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import MuiList from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import uuid from 'uuid';

import { ORDER_DESC } from '../index';
import useStyles from '../styles';
import { HeadCell } from '../types';

import ListButton from './ListButton';

const ACTION_ID = 'actions';

interface Props {
  onRequestSort?: (id: string | number) => () => void;
  order: 'asc' | 'desc';
  orderBy?: string;
  headCells: (HeadCell & { sortId?: string })[];
  bodyCells: Record<string, any>[];
}

const MobileList = (props: Props) => {
  const { order, orderBy, onRequestSort, headCells, bodyCells } = props;
  const classes = useStyles();

  return (
    <div>
      <Box m={1} boxShadow={1}>
        <Divider />
      </Box>
      {bodyCells.map((row) => (
        <Fragment key={uuid.v4()}>
          <Box display="flex">
            <Box>
              <MuiList component={Grid} className={classes.list} container>
                {headCells.map(({ id, sortId, label, isSortable }) => {
                  const sortKey = sortId ?? id;
                  const listItemClasses = classNames({
                    [classes.activeSorting]: orderBy === sortKey,
                    [classes.listItem]: true,
                  });

                  const sortable = isSortable && onRequestSort ? { onClick: onRequestSort(sortKey) } : {};

                  return (
                    id !== ACTION_ID && (
                      <ListItem
                        component={Grid}
                        key={id}
                        xs={12}
                        sm={6}
                        md={4}
                        // @ts-expect-error Deprecated `button` prop
                        button={isSortable}
                        className={listItemClasses}
                        item
                      >
                        <ListItemText
                          className={classes.listItemText}
                          primary={<ListButton {...sortable}>{row[String(id)]}</ListButton>}
                          secondary={label}
                        />
                        {orderBy === id && (
                          <ListItemIcon>
                            {order === ORDER_DESC ? <ArrowDownIcon /> : <ArrowUpIcon />}
                          </ListItemIcon>
                        )}
                      </ListItem>
                    )
                  );
                })}
              </MuiList>
            </Box>
            <Box pt={2}>{row[ACTION_ID]}</Box>
          </Box>
          <Box m={1} boxShadow={1}>
            <Divider />
          </Box>
        </Fragment>
      ))}
    </div>
  );
};

export default MobileList;
